import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { Member } from 'src/app/shared/models/member/member.model';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { environment } from '../../../environments/environment';
import { SatisfactionPopupService } from '../../shared/services/satisfaction-popup.service';
import { AnalyticsService } from '../../shared/services/utils/analytics.service';
import { HeaderChoiceItem } from './header-choices/header-choice-item';

/**
 * Header component
 */
@Component({
  selector: 'def-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Output() closeResult = new EventEmitter<void>();
  @Output() displaySearch = new EventEmitter<string>();
  @Input() close: Subject<void>;
  @Input() reset: Observable<void>;
  @Input() currentUser: Member;
  @Input() searchTerm = '';

  screenLg: 'desk' | 'portrait' | 'landscape' | 'mobile';
  displaySearchBar: boolean;

  /**
   * Analytics component common Category
   */
  readonly gaCategory = 'Global Navbar';

  currentUrl: string;
  loading = false;
  resetSubject: Subject<void> = new Subject();

  readonly youtubeLink: string = 'https://www.youtube.com/channel/UC4va3GZE--0Wz6VRDr2xjqg';

  ourContentMenuItems: HeaderChoiceItem[] = [
    {label: 'HEADER.OURCONTENT.INSPIRE', link: '/slides/inspire'},
  ];

  constructor(
    private router: Router,
    private loadingService: LoadingService,
    private analytics: AnalyticsService,
    private satisfactionPopupService: SatisfactionPopupService,
  ) {
    const routerUrl = this.router.url;
    this.currentUrl = routerUrl.split('/').length > 0 ? routerUrl.split('/')[1] : '';
    router.events.subscribe(
      () => this.currentUrl = router.url.split('/').length > 0 ? router.url.split('/')[1] : '',
    );
  }

  /**
   * Set screen width type on resize
   */
  @HostListener('window:resize')
  onResize() {
    this.screenLg = document.documentElement.offsetWidth < 600 ? 'mobile' : document.documentElement.offsetWidth < 960 ? 'portrait' : document.documentElement.offsetWidth < 1440 ? 'landscape' : 'desk';
    this.displaySearchBar = document.documentElement.offsetWidth > 1099;
  }

  ngOnInit(): void {
    this.loadingService.loadingStatus.subscribe(value => this.loading = value);

    this.reset.subscribe(() => this.resetSubject.next());
    this.onResize();

    if (environment.openSatisfactionPopup) {
      this.satisfactionPopupService.openPopupIfApplicable();
    }
  }

  onSearch(event: string) {
    if (event.length === 0) {
      this.closeResult.next();
    } else {
      this.analytics.trackEvent(this.gaCategory, 'Search in all website');
      this.displaySearch.next(event);
    }
  }
}
